import React, { useContext, useEffect, useState } from 'react';
import { Context as Auth } from '../../../services/auth/AuthContext';
import {
  Button,
  Switch,
  Table,
  Drawer,
  Form,
  Col,
  Row,
  Input,
  Space,
  Popconfirm,
  message
} from 'antd';
import { useParams } from 'react-router-dom';
import { EditOutlined, PlusOutlined, DeleteOutlined, YoutubeOutlined } from '@ant-design/icons';
import Spinner from '../../../components/navigation/Spinner';
import '../../../components/layout/layout.css';
import { getAccountById } from '../../../services/user.service';
import { getVideosubByQuery, createVideosub, patchVideosub } from '../../../services/videosub.service';
import { useTranslation } from 'react-i18next';
import { capitalize, capitalizeAll } from '../../../utils/utils';
import moment from 'moment';
moment.locale('es');

const Videosubs = (props) => {
  const { user } = useContext(Auth);
  const params = useParams();
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [videosubDrawerOpen, setVideosubDrawerOpen] = useState(false);
  const [videoDrawerOpen, setVideoDrawerOpen] = useState(false);
  const [videosub, setVideosub] = useState(null);
  const [videos, setVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [videosubForm] = Form.useForm();
  const [videoForm] = Form.useForm();
  const { t } = useTranslation();

  useEffect(() => {
    if (user.account) {
      loadAccount(params.account);
    }
  }, [user.account]);

  const showVideosubDrawer = () => {
    setVideosubDrawerOpen(true);
  };

  const onVideosubClose = () => {
    videosubForm.resetFields();
    setVideosubDrawerOpen(false);
  };

  const loadAccount = async (userId) => {
    const { status, data } = await getAccountById(userId, user.token);
    if (status === 200) {
      setAccount(data.data);
      loadVideoSubs(userId);
    }
  };

  const loadVideoSubs = async (userId) => {
    const { status, data } = await getVideosubByQuery({ account: userId, isActive: true }, user.token);
    if (status === 200) {
      setVideosub(data.data[0] || null);
      setVideos(data.data[0]?.videos || []);
      setLoading(false);
    }
  };

  const showVideoDrawer = () => {
    setVideoDrawerOpen(true);
  };

  const onVideoClose = () => {
    videoForm.resetFields();
    setSelectedVideo(null);
    setVideoDrawerOpen(false);
  };

  const createUserSub = async () => {
    const payload = {
      account: params.account,
      name: 'Videos',
      description: 'Videos de ' + account.name + ' ' + account.surname,
      isActiveSub: false,
      videos: []
    };

    const newSub = await createVideosub(payload, user.token);
    if (newSub.status === 200) {
      setLoading(true);
      await loadVideoSubs(params.account);
    }
  };

  const fillVideosubForm = (videsub) => {
    videosubForm.setFieldsValue({
      name: videsub.name,
      description: videsub.description
    });
  };

  const onVideosubFormSubmit = async () => {
    const payload = {
      name: videosubForm.getFieldValue('name'),
      description: videosubForm.getFieldValue('description')
    };

    const updateSub = await patchVideosub(videosub._id, payload, user.token);
    if (updateSub.status === 200) {
      setLoading(true);
      await loadVideoSubs(params.account);
      onVideosubClose();
    }
  };

  const onVideosubActivate = async (e) => {
    const payload = {
      isActiveSub: e
    };

    const updateSub = await patchVideosub(videosub._id, payload, user.token);
    if (updateSub.status === 200) {
      setLoading(true);
      await loadVideoSubs(params.account);
    }
  };

  const fillVideoForm = (video) => {
    videoForm.setFieldsValue({
      name: video.name,
      description: video.description,
      url: video.url,
      isVisible: video.isVisible
    });
  };

  const onVideoFormSubmit = async () => {
    const payload = {
      name: videoForm.getFieldValue('name'),
      description: videoForm.getFieldValue('description'),
      url: videoForm.getFieldValue('url'),
      isVisible: videoForm.getFieldValue('isVisible')
    };

    if (selectedVideo) {
      const { status, data } = await patchVideosub(
        videosub._id,
        {
          videos: videos.map((video) => {
            if (video._id === selectedVideo._id) {
              return { ...video, ...payload };
            }
            return video;
          })
        },
        user.token
      );
      if (status === 200) {
        setVideoDrawerOpen(false);
        videoForm.resetFields();
        setSelectedVideo(null);
        loadVideoSubs(params.account);
      }
    } else {
      const { status, data } = await patchVideosub(
        videosub._id,
        {
          videos: [...videos, payload]
        },
        user.token
      );
      if (status === 200) {
        setVideoDrawerOpen(false);
        videoForm.resetFields();
        loadVideoSubs(params.account);
      }
    }
  };

  const columns = [
    {
      title: capitalize(t('videos')),
      key: 'all',
      width: 360,
      // eslint-disable-next-line react/display-name
      render: (record) => (
        <React.Fragment>
          {record.name || '-'}
          <br />
          {record.description || '-'}
          <br />
          {record.isVisible ? capitalize(t('visible')) : capitalize(t('hidden'))}
          <br />
        </React.Fragment>
      ),
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
        multiple: 5
      },
      responsive: ['xs']
    },
    {
      title: capitalize(t('name')),
      key: 'name',
      width: '30%',
      ellipsis: true,
      // eslint-disable-next-line react/display-name
      render: (record) => record.name || '-',
      responsive: ['sm']
    },
    {
      title: capitalize(t('description')),
      key: 'description',
      width: '60%',
      ellipsis: true,
      // eslint-disable-next-line react/display-name
      render: (record) => record.description || '-',
      responsive: ['md']
    },
    {
      title: capitalize(t('visibility')),
      key: 'isVisible',
      width: '5%',
      // eslint-disable-next-line react/display-name
      render: (record) => (
        <React.Fragment>
          {record.isVisible ? capitalize(t('visible')) : capitalize(t('hidden'))}
        </React.Fragment>
      ),
      responsive: ['md']
    }
  ];

  function onChange (pagination, filters, sorter, extra) {

  }

  if (loading) {
    return (
      <Spinner/>
    );
  }

  if (!videosub) {
    return (
      <>
        <h2>{capitalize(t('videos'))}</h2>
        <div style={{
          backgroundColor: '#fff',
          padding: 18,
          border: '1px solid #f0f0f0',
          borderRadius: 8,
          marginBottom: 18,
          display: 'flex',
          flexDirection: 'column',
          gap: 8
        }}>
          <div style={{
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 14,
            display: 'flex',
            flexDirection: 'column'
          }}>
            {capitalize(t('noVideosubFound'))}

            <Button icon={<PlusOutlined />} size='large' onClick={() => createUserSub()} style={{ marginBottom: 18 }}>
              {capitalize(t('createNewVideoSub'))}
            </Button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div>
        <h2>{capitalize(t('videos'))}</h2>
        <div style={{
          backgroundColor: '#fff',
          padding: 18,
          border: '1px solid #f0f0f0',
          borderRadius: 8,
          marginBottom: 18,
          display: 'flex',
          flexDirection: 'column',
          gap: 8,
          position: 'relative'
        }}>
          <div style={{
            position: 'absolute',
            top: 18,
            right: 18,
            padding: '4px 8px'
          }}>
            <Button size='medium' onClick={() => {
              fillVideosubForm(videosub);
              showVideosubDrawer();
            }}>
              {capitalize(t('edit'))} <EditOutlined />
            </Button>
          </div>

          <div style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 14
          }}>
            <div style={{
              fontWeight: 500
            }}>{capitalize(t('name'))}:</div> {videosub?.name || '-'}
          </div>

          <div style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 14
          }}>
            <div style={{
              fontWeight: 500
            }}>{capitalize(t('description'))}:</div> {videosub?.description || '-'}
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: 14
            }}
          >
            <Switch
              onChange={(e) => {
                onVideosubActivate(e);
              }}
              checked={videosub?.isActiveSub}
            />

            <span style={{
              fontWeight: 500
            }}>{capitalize(t('activeSub'))}</span>
            <br />
          </div>
        </div>
      </div>
      <Button type="primary" shape="round" icon={<PlusOutlined />} size='large' onClick={() => {
        fillVideoForm({});
        showVideoDrawer();
      }} style={{ marginBottom: 18 }}>
        {capitalize(t('createNewVideo'))}
      </Button>
      <div>
        {/* eslint-disable-next-line react/no-unescaped-entities */}
        <b>{account ? account.name + ' ' + account.surname : ''}</b>
      </div>
      <Table
        columns={columns}
        dataSource={videos}
        rowKey={(record) => record._id || record.id || record.key || record.url || `${record.name || 'row'}-${record.created || ''}`}
        tableLayout="fixed"
        scroll={{ x: 'max-content' }}
        onChange={onChange}
        onRow={(record, rowIndex) => {
          return {
            onClick: event => {
              setSelectedVideo(record);
              fillVideoForm(record);
              showVideoDrawer();
            },
            onDoubleClick: event => {}, // double click row
            onContextMenu: event => {}, // right button click row
            onMouseEnter: event => {}, // mouse enter row
            onMouseLeave: event => {} // mouse leave row
          };
        }}
        rowClassName={'row-pointer'}
      />
      <br />
      <Drawer
        height={'460px'}
        title={capitalize(t('editVideoSub'))}
        placement={'bottom'}
        onClose={onVideosubClose}
        open={videosubDrawerOpen}
        bodyStyle={{}}
        extra={
          <Space>
            <Button onClick={onVideosubClose}>{capitalizeAll(t('cancel'))}</Button>
            <Button onClick={onVideosubFormSubmit} type='primary'>
              {capitalizeAll(t('save'))}
            </Button>
          </Space>
        }
      >
        <Form layout='vertical' form={videosubForm} onFinish={onVideosubFormSubmit}>
          <Row gutter={12}>
            <Col span={24}>
              <Form.Item
                name='name'
                label={capitalize(t('name'))}
                rules={[
                  {
                    required: true,
                    message: capitalize(t('name') + ' ' + t('isRequired'))
                  }
                ]}
              >
                <Input
                  placeholder={capitalize(t('name'))}
                  type='text'
                />
              </Form.Item>
              <Form.Item
                name='description'
                label={capitalize(t('description'))}
                rules={[
                  {
                    required: false,
                    message: capitalize(t('description') + ' ' + t('isRequired'))
                  }
                ]}
              >
                <Input
                  placeholder={capitalize(t('description'))}
                  type='text'
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
      <Drawer
        height={'460px'}
        title={
          selectedVideo
            ? capitalizeAll(t('editVideo'))
            : capitalizeAll(t('newVideo'))
        }
        placement={'bottom'}
        onClose={onVideoClose}
        open={videoDrawerOpen}
        bodyStyle={{}}
        extra={
          <Space>
            {selectedVideo && (
              <Popconfirm
                title={capitalize(t('confirmDeleteVideo'))}
                onConfirm={async () => {
                  const { status, data } = await patchVideosub(
                    videosub._id,
                    { videos: videos.filter((video) => video._id !== selectedVideo._id) },
                    user.token
                  );
                  if (status === 200) {
                    message.success(capitalize(t('videoDeleted')));
                    loadVideoSubs(params.account);
                    onVideoClose();
                  }
                }}
                okText={capitalizeAll(t('yes'))}
                cancelText={capitalizeAll(t('no'))}
              >
                <Button
                  type='primary'
                  danger
                  icon={<DeleteOutlined />}
                ></Button>
              </Popconfirm>
            )}
            <Button onClick={onVideoClose}>{capitalizeAll(t('cancel'))}</Button>
            <Button onClick={onVideoFormSubmit} type='primary'>
              {selectedVideo
                ? capitalizeAll(t('edit'))
                : capitalizeAll(t('save'))}
            </Button>
          </Space>
        }
      >
        <Form layout='vertical' form={videoForm} onFinish={onVideoFormSubmit}>
          <Row gutter={12}>
            <Col span={24}>
              <Form.Item
                name='name'
                label={capitalize(t('name'))}
                rules={[
                  {
                    required: true,
                    message: capitalize(t('name') + ' ' + t('isRequired'))
                  }
                ]}
              >
                <Input
                  placeholder={capitalize(t('name'))}
                  type='text'
                />
              </Form.Item>
              <Form.Item
                name='description'
                label={capitalize(t('description'))}
                rules={[
                  {
                    required: false,
                    message: capitalize(t('description') + ' ' + t('isRequired'))
                  }
                ]}
              >
                <Input
                  placeholder={capitalize(t('description'))}
                  type='text'
                />
              </Form.Item>
              <Form.Item
                name='url'
                label={capitalize(t('url'))}
                rules={[
                  {
                    required: true,
                    message: capitalize(t('url') + ' ' + t('isRequired'))
                  }
                ]}
              >
                <Input
                  placeholder={capitalize(t('url'))}
                  type='text'
                />
              </Form.Item>
              <Form.Item
                name='isVisible'
                label={capitalize(t('isVisible'))}
                valuePropName='checked'
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  );
};

export default Videosubs;
